import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const SelectOption = ({options, selection = "", setSelection}) => {
    return (
        <FormControl sx={{minWidth: 110}} variant="outlined" size="small">
            <InputLabel id="select-option">Options</InputLabel>
            <Select
                labelId="select-option"
                id="select-option"
                value={selection}
                label="Search options"
                onChange={(event) => setSelection(event.target.value)}
            >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                {options && options.map((option) => <MenuItem value={option.value}
                                                              key={option.value}>{option.name}</MenuItem>)}
            </Select>
        </FormControl>
    );
}
export default SelectOption;